import { Button, rem } from '@vimeo/bokeh';
import { ThumbUp } from '@vimeo/bokeh-icons';
import { IBaseDomElementProps } from '@vimeo/core/types/dom';
import { Optional } from '@vimeo/core/types/generic';

import { createDomName } from '../../../../utils/dom/identifying';

interface IQuestionItemVoteButtonProps extends IBaseDomElementProps {
  isDisabled: boolean;
  votesCount?: Optional<number>;
  onVoteQuestion(): void;
}

export function QuestionItemVoteButton({
  className = createDomName('question-item-vote-button'),
  isDisabled,
  votesCount = null,
  onVoteQuestion,
}: IQuestionItemVoteButtonProps) {
  return (
    <Button
      className={className}
      variant={'secondary'}
      size={'xs'}
      isDisabled={isDisabled}
      leftIcon={<ThumbUp boxSize={rem(16)} />}
      onClick={onVoteQuestion}
    >
      {votesCount}
    </Button>
  );
}
